module.exports = __webpack_public_path__ + "d0a77d97960f20600dc6922439f1faae.svg";